import type {
  CreateDetectorPayload,
  CreateDetectorResponse,
  DeleteDetectorResponse,
  DetectorDetailResponse,
  DetectorID,
  DetectorListResponse,
  UpdateDetectorParams,
  UpdateDetectorPayload,
  UpdateDetectorResponse,
} from '@/domains/asset-management/types/detector';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

// helper
const toUrlID = (id: string | number): string => String(id);

export const fetchDetectorList = async (params: string = ''): Promise<DetectorListResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.detectorList(params)}`;
  return await request.get(url);
};

export const fetchDetailDetector = async (dtID: DetectorID): Promise<DetectorDetailResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.detailDetector(toUrlID(dtID))}`;
  return await request.get(url);
};

export const deleteDetector = async (dtID: DetectorID): Promise<DeleteDetectorResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.deleteDetector(toUrlID(dtID))}`;
  return await request.delete(url);
};

export const createDetector = async (
  detectorData: CreateDetectorPayload
): Promise<CreateDetectorResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.createDetector}`;
  return await request.post(url, detectorData);
};

export const updateDetector = async (
  detectorData: UpdateDetectorPayload,
  params: UpdateDetectorParams
): Promise<UpdateDetectorResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.updateDetector(toUrlID(params.detector_id))}`;
  return await request.put(url, detectorData);
};
